import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import EngineerPhoto from './assets/EngineerPhoto.jpg'
import './About.css'
function About(){


    return(
        <div className="Entire-About">
            <Navbar/>
            

                <div className="About-section">

                    
                    <div className="Engineer-section">
                        <img src={EngineerPhoto} className="Engineer-image"/>
                        <div className="Engineer-caption">Mr. Imad Alomar, Head Engineer at Engineering Cubes</div>
                    </div>  

                    <div className="About-info">
                        At Engineering Cubes we care about providing our clients with the best and quickest service that we have. 
                        We have been operating in Qatar since 2018, but our head engineer, Mr. Imad Alomar has over 30 years of experience 
                        in the field so you can trust that the job will be done to the highest levels of excellency. 
                    </div>


                </div>





            <Footer/>
        </div>
    )



}


export default About;